import { render, staticRenderFns } from "./class-detail.vue?vue&type=template&id=4d58ad76&scoped=true"
import script from "./class-detail.vue?vue&type=script&lang=js"
export * from "./class-detail.vue?vue&type=script&lang=js"
import style0 from "./class-detail.vue?vue&type=style&index=0&id=4d58ad76&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d58ad76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d58ad76')) {
      api.createRecord('4d58ad76', component.options)
    } else {
      api.reload('4d58ad76', component.options)
    }
    module.hot.accept("./class-detail.vue?vue&type=template&id=4d58ad76&scoped=true", function () {
      api.rerender('4d58ad76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsteacher/teacher/class-detail.vue"
export default component.exports